import React, { forwardRef } from "react";

import { LineDividerProps } from "./LineDivider.types";
import {
    StyledLineDivider,
    StyledLinearLineDivider,
} from "./LineDivider.styles";

const LineDivider = forwardRef<HTMLDivElement, LineDividerProps>(
    (props: LineDividerProps, ref) => {
        return props.linearGradient ? (
            <StyledLinearLineDivider {...props} />
        ) : (
            <StyledLineDivider {...props} />
        );
    },
);

export default LineDivider;
